import React, { useEffect, useState } from "react";
import { TextField, Button, Chip } from "@mui/material";

import InternRequestTable from "../../Components/InternRequestTable";
import { matchOptions } from "../../utils/function";
import { optionsBranch } from "../../data/branch-data";
import { Box, Container, Paper } from "@mui/material";

import { internType } from "../../data/interntype-data";

import useMediaQuery from '@material-ui/core/useMediaQuery';
import CoopEvaluationTable from "../../Components/CoopEvaluationTable";
import { start } from "@popperjs/core";
import { current } from "@reduxjs/toolkit";
import { IconButton, Tooltip } from "@mui/material";
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import Typography from "@mui/material/Typography";



const DashboardInternshipTab = ({ items = [], allStaff = [], textActive, onRefreshData, onFilteredDataChange, activeFilter, onChipClick }) => {

  const defaultPercentages = {
    intern_location: 5,
    logbook: 5,
    assessment_visit: 30,
    assessment_present: 10,
    assessment_supervisor: 40,
    assessment_report: 10,
  };

  const [percentages, setPercentages] = useState(defaultPercentages);

  const handlePercentageChange = (event) => {
    setPercentages({
      ...percentages,
      [event.target.name]: event.target.value
    });
  };

  const handleResetPercentages = () => {
    setPercentages(defaultPercentages);
  };


  function totalAssignment_visit(assessment_visit, scale) {
    const total = parseInt(assessment_visit?.list_1)+parseInt(assessment_visit?.list_2)+parseInt(assessment_visit?.list_3)+parseInt(assessment_visit?.list_4)+parseInt(assessment_visit?.list_5)+parseInt(assessment_visit?.list_6)
    +parseInt(assessment_visit?.list_7)+parseInt(assessment_visit?.list_8)+parseInt(assessment_visit?.list_9)+parseInt(assessment_visit?.list_10)+
    parseInt(assessment_visit?.list_11)+parseInt(assessment_visit?.list_12)+parseInt(assessment_visit?.list_13)+parseInt(assessment_visit?.list_14)+parseInt(assessment_visit?.list_15)+parseInt(assessment_visit?.list_16)+parseInt(assessment_visit?.list_17)
    +parseInt(assessment_visit?.list_18)+parseInt(assessment_visit?.list_19)+parseInt(assessment_visit?.list_20)+parseInt(assessment_visit?.list_21)+parseInt(assessment_visit?.list_22)+parseInt(assessment_visit?.list_23)+parseInt(assessment_visit?.list_24);
    return scale == 1 ? total * percentages.assessment_visit / 120 : total;
  }

  function totalAssignment_present(assessment_present, scale) {
    const total = parseInt(assessment_present?.list_1)+parseInt(assessment_present?.list_2)+parseInt(assessment_present?.list_3)+parseInt(assessment_present?.list_4)+parseInt(assessment_present?.list_5)+parseInt(assessment_present?.list_6)+
    parseInt(assessment_present?.list_7)+parseInt(assessment_present?.list_8)+parseInt(assessment_present?.list_9)+parseInt(assessment_present?.list_10);
    return scale == 1 ? total * percentages.assessment_present/ 50 : total;
  }

function averageScoreLogbook(doclogbook, startDate, endDate) {
  // Filter out entries with a score of 0 and convert scores to integers
  const filteredScores = doclogbook
    .map((item) => parseInt(item?.mark, 10))
    .filter((mark) => mark > 0);

  if (filteredScores.length === 0) return 0; // Return 0 if no non-zero entries

  // Calculate total of filtered scores
  const total = filteredScores.reduce((a, b) => a + b, 0);

  // Calculate internship duration in months
  const start = new Date(startDate);
  const end = new Date(endDate);
  const months = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());
  
  // Determine required minimum logbook count based on duration
  // 4-month internship = 4 logbooks minimum, 6-month internship = 6 logbooks minimum
  const requiredLogbooks = months <= 4 ? 4 : 6;

  // Determine divisor: if submitted more than required, divide by actual count
  // Otherwise, divide by required minimum (to penalize incomplete submissions)
  // ถ้าส่งมากกว่าขั้นต่ำ ให้หารด้วยจำนวนที่ส่งจริง / ถ้าส่งไม่ครบ ให้หารด้วยจำนวนขั้นต่ำ
  const divisor = filteredScores.length > requiredLogbooks ? filteredScores.length : requiredLogbooks;

  return parseFloat((total / divisor * percentages.logbook / 5).toFixed(1));
}

  const [rowsData, setRowsData] = useState([]);
  const [excelDataSet, setExcelDataSet] = useState([]);
  const isMobile = useMediaQuery('(max-width:767px)');


  const onHandleItems = (items) => {
   // console.log("onHandleItems", items);

    const rows = items.map((row) => {
      let dataJson;
      
      if (row.internLocation) {
        dataJson = JSON.parse(row?.internLocation?.manual_data);
      }

      

      return {
        req_id: row?.req_id,
        st_id: row?.st_id,
        name: `${row?.internStudent?.name}, ${matchOptions(
          optionsBranch,
          row?.internStudent?.b_id
        )}`,
        company: row?.company?.name,
        address: `${row.company.address} ${row.company.subdistrict}${row.company.district} ${row.company.province} ${row.company.zip}`,
        type_internship: matchOptions(internType, row.type_internship),
        intern_period: `${row.start_date} ถึง ${row.end_date}`,
        status: new Date(row?.start_date).getTime(),
        supervisor: row.supervisor,

        updated_at: "",
        form: row?.internLocation?.date_updated ?? "",
        internLocation_created: row?.internLocation?.date_created ?? "",
        start_date: row.start_date,
        end_date: row.end_date,
        b_id: row?.internStudent?.b_id,

        addressIntern: dataJson
          ? `${dataJson?.company.address.no} ${
              dataJson?.company.address.province.includes("กรุงเทพ")
                ? "แขวง"
                : "ต."
            }` +
            `${dataJson?.company.address.sub_district} ${
              dataJson?.company.address.province.includes("กรุงเทพ")
                ? "เขต"
                : "อ."
            }` +
            `${dataJson?.company.address.district} ${
              dataJson?.company.address.province.includes("กรุงเทพ")
                ? " "
                : "จ."
            }${dataJson?.company.address.province}` +
            ` ${dataJson?.company.address.postcode}`
          : `${row.company.address} ${
              row.company.province.includes("กรุงเทพ") ? "แขวง" : "ต."
            }` +
            `${row.company.subdistrict} ${
              row.company.province.includes("กรุงเทพ") ? "เขต" : "อ."
            }${row.company.district}` +
            ` ${row.company.province.includes("กรุงเทพ") ? "" : "จ."}${
              row.company.province
            } ${row.company.zip}`,

        addressUrl: dataJson?.location.link ?? "",

        auditorName: dataJson?.auditor.name ?? "",
        auditorPosition: dataJson?.auditor.position ?? "",
        auditorDepartment: dataJson?.auditor.department ?? "",
        auditorEmail: dataJson?.auditor.fax ?? "",
        auditorTel: dataJson?.auditor.tel ?? "",

        hrName: dataJson?.person.name ?? "",
        hrPosition: dataJson?.person.position ?? "",
        hrDepartment: dataJson?.person.department ?? "",
        hrEmail: dataJson?.person.email ?? "",
        hrTel: dataJson?.person.tel ?? "",

        jobDescription: dataJson?.job.desc ?? "",
        jobPosition: dataJson?.job.position ?? "",

        logbooklist: row?.doclogbook ?? "",
        logbookscore: averageScoreLogbook(row?.doclogbook, row?.start_date, row?.end_date),

        internReport: row?.internReport,
        internDetailMark: row?.proposalCoop?.mark * percentages.intern_location /5 ?? "",
        assessment_visit: row?.assessment_visit,
        totalAssignment_visit: totalAssignment_visit(row?.assessment_visit,1),
        assessment_present: row?.assessment_present,
        totalAssignment_present: totalAssignment_present(row?.assessment_present,1),

        assessment_company: row?.assessment_company,
        assessment_company_total: row?.assessment_company?.total_score 
          ? (parseFloat(row.assessment_company.total_score) / parseFloat(row.assessment_company.max_score || 200)) * percentages.assessment_supervisor
          : 0,
        assessment_report_obj: row?.assessment_report, // เก็บ Object เดิมไว้สำหรับการคำนวณในตาราง
        assessment_report: row?.assessment_report?.total_score 
          ? parseFloat(row.assessment_report.total_score).toFixed(1)
          : '-', // แสดงเป็นตัวเลข (คะแนนดิบ) สำหรับ copy
        assessment_report_total: row?.assessment_report?.total_score 
          ? (parseFloat(row.assessment_report.total_score) / parseFloat(row.assessment_report.max_score || 100)) * percentages.assessment_report
          : 0,

        

      };
    });

    //const sortData = rows.sort((a, b) => (a.st_id > b.st_id ? 1 : -1));

    const sortData = rows.sort((a, b) => (a.company > b.company ? 1 : -1));

    return sortData;
  };

  const onHandleExcel = (dataArr = []) => {
   

    const excelData = dataArr
      .filter((item) => {
        const itemStartDate = new Date(item.start_date).getTime();
        const itemEndDate = new Date(item.end_date).getTime() + 5184000000; // +60 วัน
      
        if (dateRange.startDate && dateRange.endDate) {
          const selectedStartDate = new Date(dateRange.startDate).getTime();
          const selectedEndDate = new Date(dateRange.endDate).getTime();
          return itemStartDate >= selectedStartDate && itemEndDate <= selectedEndDate;
        }
      
        // Default current date filter
        const currentDate = new Date().getTime();
        return currentDate > itemStartDate && currentDate < itemEndDate;
      }).map((row) => {
        // console.log("row", row);
        return {
          
          req_id: row?.req_id,
          st_id: row?.st_id,
          name: row?.name.split(", ")[0],
          branch: row?.name.split(", ")[1],
          company: row?.company,
          address: row?.address,
          province: row?.company.province,
          //`${row.company.address} ${row.company.subdistrict} ${row.company.district} ${row.company.province} ${row.company.zip}`,
          type_internship: row?.type_internship,
          intern_period: `${row?.start_date} ถึง ${row?.end_date}`,
          form: row?.form,

          addressIntern: row?.addressIntern,
          addressUrl: row?.addressUrl,

          auditorName: row?.auditorName,
          auditorPosition: row?.auditorPosition,
          auditorDepartment: row?.auditorDepartment,
          auditorEmail: row?.auditorEmail,
          auditorTel: row?.auditorTel,

          hrName: row?.hrName,
          hrPosition: row?.hrPosition,
          hrDepartment: row?.hrDepartment,
          hrEmail: row?.hrEmail,
          hrTel: row?.hrTel,

          jobDescription: row?.jobDescription,
          jobPosition: row?.jobPosition,
          internDetailMark: parseInt(row?.internDetailMark),
          

          logbook1: row?.logbooklist[0]?.link,

          logbookscore: averageScoreLogbook(row?.logbooklist, row?.start_date, row?.end_date),
          totalAssignment_visit: totalAssignment_visit(row?.assessment_visit,1),
          totalAssignment_present: totalAssignment_present(row?.assessment_present,1),
          assessment_company: row?.assessment_company?.total_score 
            ? (parseFloat(row.assessment_company.total_score) / parseFloat(row.assessment_company.max_score || 200)) * percentages.assessment_supervisor
            : 0,
          assessment_report: row?.assessment_report?.total_score 
            ? (parseFloat(row.assessment_report.total_score) / parseFloat(row.assessment_report.max_score || 100)) * percentages.assessment_report
            : 0,
          
          
          
          //percentages.assessment_report/100,
          
          total:[row?.logbookscore, row?.internDetailMark, row?.totalAssignment_visit, row?.totalAssignment_present, row?.assessment_company_total, row?.assessment_report]
          .map(parseFloat) // Convert all values to float
          .filter(value => !isNaN(value)) // Keep only values that are not NaN
          .reduce((acc, value) => acc + value, 0) // Sum up all non-NaN values
          .toFixed(1) // Round to 1 decimal places



          // total: averageScoreLogbook(row?.logbooklist) +
          // totalAssignment_visit(row?.assessment_visit,1)+
          // totalAssignment_present(row?.assessment_present,1)+
          // parseInt(row?.internDetailMark)+
          // parseInt(row?.assessment_report?.total*percentages.assessment_report/100)+
          // parseFloat(row?.assessment_company?.total)*percentages.assessment_supervisor/100,


        };
      });
      
    setExcelDataSet(excelData.sort((a, b) => (a.company > b.company ? 1 : -1)));
  };




  const [dateRange, setDateRange] = useState({
    startDate: '',
    endDate: ''
  });

  const handleDateChange = (event) => {
    setDateRange({
      ...dateRange,
      [event.target.name]: event.target.value
    });
  };

  const handleResetDates = () => {
    setDateRange({
      startDate: '',
      endDate: ''
    });
  };

  const getCurrentDate = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const dd = String(today.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };

  const currentDate = getCurrentDate();
  


  useEffect(() => {
    if (items.length) {
      //console.log("useEffect", items);
      const handleItem = onHandleItems(items);
      setRowsData(handleItem);
      onHandleExcel(handleItem);
    }
  }, [items]);

  useEffect(() => {
    // Recalculate table data when percentages change
    if (items.length) {
      const handleItem = onHandleItems(items);
      setRowsData(handleItem);
      onHandleExcel(handleItem);
    }
  }, [percentages]);

  // คำนวณสถิติจากข้อมูลที่กรองตามวันที่แล้ว
  const calculateStatistics = () => {
    const filtered = rowsData.filter((item) => {
      const itemStartDate = new Date(item.start_date).getTime();
      const itemEndDate = new Date(item.end_date).getTime() + 5184000000; // +60 วัน
      
      if (dateRange.startDate && dateRange.endDate) {
        const selectedStartDate = new Date(dateRange.startDate).getTime();
        const selectedEndDate = new Date(dateRange.endDate).getTime();
        return itemStartDate >= selectedStartDate && itemEndDate <= selectedEndDate;
      }
      
      return new Date().getTime() > itemStartDate && 
             new Date().getTime() < itemEndDate;
    });

    if (filtered.length === 0) return {
      projectDetail: { count: 0, total: 0, percentage: 0 },
      logbook: { count: 0, total: 0, percentage: 0 },
      visit: { count: 0, total: 0, percentage: 0 },
      present: { count: 0, total: 0, percentage: 0 },
      supervisor: { count: 0, total: 0, percentage: 0 },
      report: { count: 0, total: 0, percentage: 0 }
    };

    const total = filtered.length;
    
    // รายละเอียดโครงงาน (ยังไม่ได้ประเมิน)
    const projectDetailNotDoneCount = filtered.filter(item => 
      !item?.internDetailMark || parseFloat(item?.internDetailMark) <= 0
    ).length;
    
    // Logbook (ยังไม่มี)
    const logbookNotDoneCount = filtered.filter(item => 
      !item?.logbooklist || item.logbooklist.length === 0
    ).length;
    
    // การนิเทศ (ยังไม่ได้นิเทศ)
    const visitNotDoneCount = filtered.filter(item => 
      !item?.totalAssignment_visit || parseFloat(item?.totalAssignment_visit) <= 0
    ).length;
    
    // การนำเสนอ (ยังไม่ได้นำเสนอ)
    const presentNotDoneCount = filtered.filter(item => 
      !item?.totalAssignment_present || parseFloat(item?.totalAssignment_present) <= 0
    ).length;
    
    // พี่เลี้ยง (ยังไม่ได้ประเมิน)
    const supervisorNotDoneCount = filtered.filter(item => 
      !item?.assessment_company?.total_score || parseFloat(item?.assessment_company?.total_score) <= 0
    ).length;

    // เล่มรายงาน (ยังไม่ส่ง)
    const reportNotDoneCount = filtered.filter(item => 
      !item?.assessment_report?.total_score || parseFloat(item?.assessment_report?.total_score) <= 0
    ).length;

    return {
      projectDetail: { 
        count: projectDetailNotDoneCount, 
        total: total, 
        percentage: total > 0 ? Math.round((projectDetailNotDoneCount / total) * 100) : 0 
      },
      logbook: { 
        count: logbookNotDoneCount, 
        total: total, 
        percentage: total > 0 ? Math.round((logbookNotDoneCount / total) * 100) : 0 
      },
      visit: { 
        count: visitNotDoneCount, 
        total: total, 
        percentage: total > 0 ? Math.round((visitNotDoneCount / total) * 100) : 0 
      },
      present: { 
        count: presentNotDoneCount, 
        total: total, 
        percentage: total > 0 ? Math.round((presentNotDoneCount / total) * 100) : 0 
      },
      supervisor: { 
        count: supervisorNotDoneCount, 
        total: total, 
        percentage: total > 0 ? Math.round((supervisorNotDoneCount / total) * 100) : 0 
      },
      report: { 
        count: reportNotDoneCount, 
        total: total, 
        percentage: total > 0 ? Math.round((reportNotDoneCount / total) * 100) : 0 
      }
    };
  };

  const statistics = calculateStatistics();






  const headCells = [
    {
      id: "order",
      numeric: true,
      disablePadding: false,
      label: "#",
    },

    {
      id: "req_id",
      numeric: true,
      disablePadding: false,
      label: "Request ID	",
    },

    {
      id: "name",
      numeric: false,
      disablePadding: false,
      label: "ชื่อ - สกุล	",
      enableCopy: true, // Enable copy functionality for this column
    },

    {
      id: "supervisor",
      numeric: false,
      disablePadding: false,
      label: "อาจารย์นิเทศ",
    },

    {
      id: "intern_location",
      numeric: true,
      disablePadding: false,
      label: <>รายละเอียด <br /> โครงงาน
      <br />({percentages.intern_location}%)
      </>,
    },
    {
      id: "logbook",
      numeric: true,
      disablePadding: false,
      label: <>Logbook
      <br />({percentages.logbook}%)
      </>,
    },
    {
      id: "assessment_visit",
      numeric: true,
      disablePadding: false,
      label: <>การนิเทศ
      <br />({percentages.assessment_visit}%)
      </>,
    },
    {
      id: "assessment_present",
      numeric: true,
      disablePadding: false,
      label: <>การนำเสนอ
      <br />({percentages.assessment_present}%)
      </>,
    },
    {
      id: "assessment_supervisor",
      numeric: true,
      disablePadding: false,
      label: <>พี่เลี้ยง
      <br />({percentages.assessment_supervisor}%)
      </>,
    },
    {
      id: "assessment_report",
      numeric: true,
      disablePadding: false,
      label: <>เล่มรายงาน
      <br />({percentages.assessment_report}%)
      </>,
    },
   
    {
      id: "total",
      numeric: true,
      disablePadding: false,
      label: <>รวม
        <br />({Object.values(percentages).reduce((acc, curr) => acc + Number(curr), 0)}%)

      </>,
    },
   
  ];

  return (
    <>
      <Box mb={2} mt={2} display="flex" gap={1} alignItems="start">
        <Box display="flex" gap={1}>
          <TextField
            type="date"
            name="startDate"
            label="วันที่เริ่มต้น"
            value={dateRange.startDate}
            onChange={handleDateChange}
            InputLabelProps={{ shrink: true }}
            size="small"
            sx={{ 
              minWidth: '150px',
              '& .MuiInputBase-input': { py: 0.75 }
            }}
          />
          <TextField
            type="date"
            name="endDate"
            label="วันที่สิ้นสุด"
            value={dateRange.endDate}
            onChange={handleDateChange}
            InputLabelProps={{ shrink: true }}
            size="small"
            sx={{ 
              minWidth: '150px',
              '& .MuiInputBase-input': { py: 0.75 }
            }}
          />
          <Tooltip title="รีเซ็ตวันที่">
            <IconButton
              onClick={handleResetDates}
              size="small"
              color="primary"
            >
              <RestartAltIcon />
            </IconButton>
          </Tooltip>
        </Box>
        <Box flexGrow={1} display="flex" justifyContent="flex-end">
          <Typography variant="body2" color="textSecondary">
            ช่วงเวลาที่เลือก: {dateRange.startDate || currentDate} - {dateRange.endDate || currentDate}
          </Typography>
        </Box>
      </Box>

      <Box mb={2} mt={2} display="flex" gap={1} alignItems="center">
        <TextField
          type="number"
          name="intern_location"
          label="รายละเอียดโครงงาน (%)"
          value={percentages.intern_location}
          onChange={handlePercentageChange}
          InputLabelProps={{ shrink: true }}
          size="small"
          sx={{ 
            minWidth: '60px',
            '& .MuiInputBase-input': { py: 0.75 }
          }}
        />
        <TextField
          type="number"
          name="logbook"
          label="Logbook (%)"
          value={percentages.logbook}
          onChange={handlePercentageChange}
          InputLabelProps={{ shrink: true }}
          size="small"
          sx={{ 
            minWidth: '60px',
            '& .MuiInputBase-input': { py: 0.75 }
          }}
        />
        <TextField
          type="number"
          name="assessment_visit"
          label="การนิเทศ (%)"
          value={percentages.assessment_visit}
          onChange={handlePercentageChange}
          InputLabelProps={{ shrink: true }}
          size="small"
          sx={{ 
            minWidth: '60px',
            '& .MuiInputBase-input': { py: 0.75 }
          }}
        />
         <TextField
          type="number"
          name="assessment_present"
          label="การนำเสนอ (%)"
          value={percentages.assessment_present}
          onChange={handlePercentageChange}
          InputLabelProps={{ shrink: true }}
          size="small"
          sx={{ 
            minWidth: '60px',
            '& .MuiInputBase-input': { py: 0.75 }
          }}
        />
       
        <TextField
          type="number"
          name="assessment_supervisor"
          label="พี่เลี้ยง (%)"
          value={percentages.assessment_supervisor}
          onChange={handlePercentageChange}
          InputLabelProps={{ shrink: true }}
          size="small"
          sx={{ 
            minWidth: '60px',
            '& .MuiInputBase-input': { py: 0.75 }
          }}

        />
         <TextField
          type="number"
          name="assessment_report"
          label="เล่มรายงาน (%)"
          value={percentages.assessment_report}
          onChange={handlePercentageChange}
          InputLabelProps={{ shrink: true }}
          size="small"
          sx={{ 
            minWidth: '60px',
            '& .MuiInputBase-input': { py: 0.75 }
          }}
        />

        <Tooltip title="รีเซ็ตเปอร์เซ็นต์">
          <IconButton
            onClick={handleResetPercentages}
            size="small"
            color="primary"
            sx={{ ml: 0 }}
          >
            <RestartAltIcon />
          </IconButton>
        </Tooltip>
      </Box>

      <CoopEvaluationTable
        textActive={textActive}
        tableColumn={headCells}
        tableData={rowsData.filter((item) => {
          const itemStartDate = new Date(item.start_date).getTime();
          const itemEndDate = new Date(item.end_date).getTime() + 5184000000; // +60 วัน
          
          // Date range filter
          let passDateFilter = false;
          if (dateRange.startDate && dateRange.endDate) {
            const selectedStartDate = new Date(dateRange.startDate).getTime();
            const selectedEndDate = new Date(dateRange.endDate).getTime();
            passDateFilter = itemStartDate >= selectedStartDate && itemEndDate <= selectedEndDate;
          } else {
            passDateFilter = new Date().getTime() > itemStartDate && new Date().getTime() < itemEndDate;
          }
          
          if (!passDateFilter) return false;
          
          // Active filter (chip filter) - แสดงเฉพาะรายการที่ยังไม่ได้ทำ
          if (activeFilter) {
            switch (activeFilter) {
              case 'projectDetail':
                // ยังไม่มีคะแนนรายละเอียดโครงงาน
                return !item?.internDetailMark || parseFloat(item?.internDetailMark) <= 0;
              case 'logbook':
                // ยังไม่มี logbook
                return !item?.logbooklist || item.logbooklist.length === 0;
              case 'visit':
                // ยังไม่ได้นิเทศ (ไม่มีคะแนนนิเทศ)
                return !item?.totalAssignment_visit || parseFloat(item?.totalAssignment_visit) <= 0;
              case 'present':
                // ยังไม่ได้นำเสนอ (ไม่มีคะแนนนำเสนอ)
                return !item?.totalAssignment_present || parseFloat(item?.totalAssignment_present) <= 0;
              case 'supervisor':
                // ยังไม่มีคะแนนพี่เลี้ยง - ใช้ assessment_company.total_score
                const supervisorScore = parseFloat(item?.assessment_company?.total_score);
                const hasSupervisorScore = !isNaN(supervisorScore) && supervisorScore > 0;
                return !hasSupervisorScore;
              case 'report':
                // ยังไม่ส่งรายงาน - ใช้ assessment_report.total_score
                return !item?.assessment_report?.total_score || parseFloat(item?.assessment_report?.total_score) <= 0;
              default:
                return true;
            }
          }
          
          return true;
        })}

        allStaff={allStaff}
        excelDataSet={excelDataSet}
        percentages={percentages}
        onRefreshData={onRefreshData}
        statistics={statistics}
        activeFilter={activeFilter}
        onChipClick={onChipClick}
      />
    </>
  );
};

export default DashboardInternshipTab;